import axios from '@/http/axios';

export default {
  create: (config: any = {}) => {
    return axios.post('/questions/', config);
  },
  update: (oid, config: any = {}) => {
    return axios.put(`/questions/${oid}`, config);
  },
  delete: (oid) => {
    return axios.delete(`/questions/${oid}`);
  },
  sortQuestionDependencies: (oid, config) => {
    return axios.put(`/questions/${oid}/question-dependencies/sort`, config);
  },
  sortQuestionNegativeRules: (oid, config) => {
    return axios.put(`/questions/${oid}/question-negative-rules/sort`, config);
  },
};
